import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Eyebrow } from "./Blocks";

const TONE = { "Draw Results": "bg-brand-red", "Policy Update": "bg-brand-blue", Guide: "bg-amber-500" };

export const fmtPostDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" }) : "");

export const PostCover = ({ post, large }) => (
  <div className={`relative overflow-hidden bg-navy ${large ? "h-64 rounded-2xl md:h-80" : "h-44 rounded-t-xl"}`} aria-hidden="true">
    <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full border-[28px] border-white/5" />
    <div className="absolute -bottom-24 left-1/3 h-72 w-72 rounded-full border-[36px] border-brand-blue/10" />
    <div className="absolute inset-0 p-6 flex flex-col justify-between">
      <span className={`self-start rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white ${TONE[post.category] || "bg-brand-red"}`}>{post.category}</span>
      <div className="flex items-end justify-between gap-4">
        <p className={`font-display text-white/90 ${large ? "text-2xl md:text-3xl max-w-xl" : "text-lg line-clamp-2"}`}>{large ? "Chahal Overseas Immigration · News & guides" : post.title}</p>
        <span className="shrink-0 rounded-md bg-white p-1.5"><img src="/assets/logo.webp" alt="" width="40" height="24" className="h-6 w-auto" loading="lazy" /></span>
      </div>
    </div>
  </div>
);

export const PostCard = ({ post, i = 0 }) => (
  <Link to={`/blog/${post.slug}`} className="group reveal flex flex-col overflow-hidden rounded-xl border border-line bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(8,30,58,.10)]" style={{ animationDelay: `${i * 50}ms` }} data-testid={`post-card-${post.slug}`}>
    <PostCover post={post} />
    <div className="flex flex-1 flex-col p-6">
      <p className="text-xs text-slate-500">{fmtPostDate(post.published_at)}</p>
      <h3 className="mt-2 text-lg font-bold leading-snug text-navy group-hover:text-brand-red">{post.title}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600 line-clamp-3">{post.excerpt}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-red">Read more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
    </div>
  </Link>
);

export const LatestPosts = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/posts", { params: { limit: 3 } }).then((r) => setPosts(r.data)).catch(() => {}); }, []);
  if (!posts.length) return null;
  return (
    <section className="py-24" data-testid="latest-posts">
      <div className="container-x">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div><Eyebrow>IRCC updates & guides</Eyebrow><h2 className="mt-4 font-display text-3xl text-navy sm:text-4xl">Latest immigration news.</h2></div>
          <Link to="/blog" className="btn-outline self-start md:self-auto" data-testid="latest-posts-all">All news & guides <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-3">{posts.map((p, i) => <PostCard key={p.id} post={p} i={i} />)}</div>
      </div>
    </section>
  );
};
